export default "__VITE_ASSET__vQapRfNQ__"